import utils from '@/lib/utils'
import api from '@/lib/api'
import _ from 'lodash'
const wordMetas = {
  // collect_type: {
  //   icon: 'maps_home_work',
  //   label: '采血类型'
  // }
}
function createGetters (types) {
  const result = {}
  for (const type of types) {
    result[_.camelCase(`get_${type}_options`)] = (state, getters) => getters.getWordsOptionsByType(type)
    result[_.camelCase(`get_${type}_list`)] = (state, getters) => getters.getWordsListByType(type)
    result[_.camelCase(`get_${type}_map`)] = (state, getters) => getters.getWordsMapByType(type)
    result[_.camelCase(`get_${type}`)] = (state, getters) => id => getters.getWord(type, id)
  }
  return result
}
function createWordOption (model) {
  return Object.freeze({ value: model.id, text: model.text, label: model.text, textPy: model.textPy, model: model })
}

function fillCollectCategorySearchFilter (collectCategoryList, collectTypeList, collectLocationList) {
  const othersCats = []
  for (const cat of collectCategoryList) {
    if (cat.data) {
      if (cat.data.others) {
        othersCats.push(cat)
      } else {
        cat.data.searchFilter = [{
          collectTypeIds: collectTypeList?.filter(type => utils.matchFlags(type.data, cat.data))?.map(item => item.id) ?? [],
          collectLocationIds: collectLocationList?.filter(location => utils.matchFlags(location.data, cat.data))?.map(item => item.id) ?? []
        }]
      }
    } else {
      console.warn(`词条 ${cat.type}\\${cat.id} 未设置data`)
    }
  }
  if (othersCats?.length) {
    const map = new Map(utils.crossJoin([
      collectTypeList.map(item => item.id),
      collectLocationList.map(item => item.id)
    ]).map(row => [
      row.join(','),
      ({ collectTypeIds: [row[0]], collectLocationIds: [row[1]] })
    ]))
    for (const cat of collectCategoryList) {
      if (cat.data && !cat.data.others && cat.data.searchFilter) {
        const searchFilter = cat.data.searchFilter
        for (const searchFilterItem of searchFilter) {
          const mapKeys = utils.crossJoin([searchFilterItem.collectTypeIds, searchFilterItem.collectLocationIds]).map(row => row.join(','))
          for (const mapKey of mapKeys) {
            map.delete(mapKey)
          }
        }
      }
    }
    const othersSearchFilter = [...map.values()]
    for (let catIndex = 0; catIndex < othersCats.length; catIndex++) {
      const othersCat = othersCats[catIndex]
      if (catIndex > 0) {
        console.warn(`词条 ${othersCat.type}\\${othersCat.id} 第${catIndex + 1}次设置了others属性`)
      }
      othersCat.data.searchFilter = othersSearchFilter
    }
  }
}

export default function () {
  return {
    namespaced: true,
    state: {
      words: null,
      wordsMap: null,
      wordsListsByType: null,
      wordsMapsByType: null
    },
    getters: {
      wordsLoaded: state => !!state.words,
      getWordsListByType: state => (type) => {
        return state?.wordsListsByType ? state.wordsListsByType[type] : null
      },
      getWordsOptionsByType: (state, getters) => (type) => {
        return getters.getWordsListByType(type)?.map(createWordOption) ?? []
      },
      getWordsMapByType: state => (type) => {
        return state?.wordsMapsByType ? state.wordsMapsByType[type] : null
      },
      getWord: state => (id) => {
        return state.wordsMap?.get(id)
      },
      getWordText: state => (id) => {
        return state.wordsMap?.get(id)?.text
      },
      getWordByText: state => (type, text) => {
        const list = state?.wordsListsByType ? state.wordsListsByType[type] : null
        return list?.find(item => item.text === text)
      },
      getWordIconByType: state => type => wordMetas[type]?.icon,
      getWordLabelByType: state => type => wordMetas[type]?.label,

      ...createGetters(Object.keys(wordMetas))
    },
    mutations: {
      setWords: function (state, newWords) {
        if (!newWords) return
        for (let index = 0; index < newWords.length; index++) {
          const word = newWords[index]
          if (word.data) {
            word.data = JSON.parse(word.data)
          }
          word.value = word.id
          const handler = wordMetas[word.type]?.handler
          handler && handler(word)
        }
        const wordsListsByType = newWords ? _.groupBy(newWords, item => item.type) : null
        const wordsMapsByType = Object.create(null)
        for (var key of Object.keys(wordsListsByType)) {
          const group = wordsListsByType[key]
          if (group) {
            wordsListsByType[key].sort((item1, item2) => item1.sort - item2.sort)
          }
          wordsMapsByType[key] = new Map(group?.map(item => [item.id, item]))
        }

        // 计算collectCategory 值
        const collectTypeList = wordsListsByType.collect_type
        const collectLocationList = wordsListsByType.collect_location
        fillCollectCategorySearchFilter(wordsListsByType.collect_category, collectTypeList, collectLocationList)
        fillCollectCategorySearchFilter(wordsListsByType.collect_category_whole_handover, collectTypeList, collectLocationList)

        state.words = utils.deepFreeze(newWords)
        state.wordsMap = utils.deepFreeze(new Map(newWords.map(item => [item.id, item])))
        state.wordsListsByType = utils.deepFreeze(wordsListsByType)
        state.wordsMapsByType = utils.deepFreeze(wordsMapsByType)
        return state.words
      }
    },
    actions: {
      async loadWords (context, { force = false } = {}) {
        if (force || !context.getters.wordsLoaded) {
          const result = await api.bis.post('/dic/wordEntry/search', {
            filters: {},
            page: {
              pageNum: 1,
              pageSize: 99999999
            }
          })
          result.notifyIfFail()
          if (result.success) {
            context.commit('setWords', result.data.data)
          }
          return result.success
        } else {
          return true
        }
      }
    }
  }
}
